// extracted by mini-css-extract-plugin
export var aircallIframe = "_ca-3";
export var fabContainer = "_ca-5";
export var fabRinging = "_ca-6";
export var loadingOverlay = "_ca-4";
export var pulse = "_ca-7";
export var widgetContent = "_ca-2";
export var widgetPanel = "_ca-0";
export var widgetPanelExpanded = "_ca-1";